module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if( factoryKey === 'control_line_chart' || factoryKey === 'control_bar_chart' ){ 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Filter</span></div>\r\n<div id=\"setDynamic\" class=\"row\">\r\n    <div class=\"col-md-12 form-group-flex\" id=\"dynamic-filter\">\r\n        <input type=\"checkbox\" name='setDynamicFilter' class=\"form-radio-group\"><span class=\"form-group-label\">Can set dynamic filter</span>\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\" id=\"respect-dynamic-filter\">\r\n        <input type=\"checkbox\" name='respectDynamicFilter' class=\"form-radio-group\"><span title=\"Respect dynamic filter\" class=\"form-group-label\">Respect dynamic filter</span>\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\" id=\"override-previous\">\r\n        <input type=\"checkbox\" name='additiveDynamicFilter' class=\"form-radio-group\"><span class=\"form-group-label\">Override previous filter</span>\r\n    </div>\r\n</div>\r\n\r\n")
    ;  }else{ 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Filter</span></div>\r\n<div id=\"setDynamic\" class=\"row\">\r\n    <div class=\"col-md-12 form-group-flex\" id=\"dynamic-filter\" style=\"padding-right:1px;\">\r\n        <input type=\"checkbox\" name='setDynamicFilter' class=\"form-radio-group\">\r\n        <label class=\"form-group-label\"> Can set dynamic filter</label>\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\" id=\"respect-dynamic-filter\" style=\"padding-right:1px\">\r\n        <input type=\"checkbox\" name='respectDynamicFilter' class=\"form-radio-group\">\r\n        <label title=\"Respect dynamic filter\" class=\"form-group-label\"> Respect dynamic filter</label>\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\" id=\"override-previous\" style=\"padding-right:1px\">\r\n        <input type=\"checkbox\" name='additiveDynamicFilter' class=\"form-radio-group\">\r\n        <label class=\"form-group-label\"> Override previous filter</label>\r\n    </div>\r\n</div>\r\n")
    ; }
    ; __append("\r\n\r\n")
  }
  return __output;

}